import { FC } from 'react';
import cn from 'classnames';
import { BLOCKS } from '@contentful/rich-text-types';

import styles from 'components/Sections/OrangeAlert/OrangeAlert.module.scss';
import { CommonRichText, Content } from 'components/Shared/SharedComponents';
import { OrangeAlertListItemBlockBasedInterface } from 'components/Sections/OrangeAlert/declarations';
import { RichTextParsersConfig } from 'types/objectTypes';
import { capitalizeFirstLetter } from 'lib/text.service';
import { Icon } from 'components/Sections/OrangeAlert/Icon';

const getParsersConfig = (): RichTextParsersConfig => ({
  [BLOCKS.HEADING_2]: {
    classNames: cn(styles.heading, styles.headingH1),
  },
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.contentLiParagraph,
  },
});

const OrangeAlertListItemBlockBased: FC<OrangeAlertListItemBlockBasedInterface> = ({
  index,
  step,
  mobileItemsLayout,
  mobileViewMaxWidth,
  commonTabletMaxWidth,
}) => {
  if (!step) {
    return null;
  }

  const { image, slug } = step;
  const isDivider = slug === 'divider';

  const content = isDivider ? null : (
    <>
      <Icon
        image={image!}
        mobileItemsLayout={mobileItemsLayout}
        mobileViewMaxWidth={mobileViewMaxWidth}
        commonTabletMaxWidth={commonTabletMaxWidth}
      />
      <div className={styles.content}>
        <CommonRichText content={step?.richTitle} parsersConfig={getParsersConfig()} />
        <Content
          richText={step?.content}
          config={getParsersConfig()}
        />
      </div>
    </>
  );

  return (
    <li className={cn(
      styles.alertContentLi,
      styles.blockBasedContentLi,
      styles[`alertContentLi${capitalizeFirstLetter(slug || '')}`],
      isDivider ? styles.blockBasedDivider : styles.alertContentLiNoLink,
      index === 0 && styles.firstStep,
    )}
    >
      {content}
    </li>
  );
};

export default OrangeAlertListItemBlockBased;
